<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/DHT1/DHT1.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">2DHT130 混动专用变速器</div>
                <div class="detail-banner-desc transmission">
                    双电机2速混动专用变速器
                    <div class="detail-desc">
                        <div>
                            智能模式切换，低速增程、中高速直驱；<br />
                        </div>
                        <div>
                            全场景覆盖，发动机直驱两挡搭配三擎九模 ；<br />
                        </div>
                        <div>
                           高速工况高效直驱，P3电机智能解耦，降低损耗。<br />
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    核心配置
                </div>

                <div class="spec-row">
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数：驱动电机
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">130kW</div>
                                    <div class="k">峰值功率</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">295N·m</div>
                                    <div class="k">峰值输出扭矩</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">18500rpm</div>
                                    <div class="k">最高转速</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1</div>
                                    <div class="k">挡位数量</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/DHT1/DHT1-2.jpg" alt="200-1-02">
                    </div>
                </div>

            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '2DHT130 混动专用变速器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/DHT1.html'
};

import { createApp } from 'vue';
import App from './DHT1.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./DHT1.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
